import React from 'react';
import PropTypes from 'prop-types';
import { useTabsNavigationStore, APP_VIEWS } from '../../../stores';
import { SIDEBAR_FOOTER } from '../model/navModel';

// .side-foot — глобальные view: Организаторы / Лагерь (настройки лагеря).
// Не путать "Лагерь" (APP_VIEWS.CAMP_SETTINGS) с разделом "Смена" (SHIFT_SECTIONS.SETTINGS).
export default function SidebarFooter({ onNavigate }) {
    const currentView = useTabsNavigationStore(state => state.currentView);
    const showOrganizers = useTabsNavigationStore(state => state.showOrganizers);
    const showCampSettings = useTabsNavigationStore(state => state.showCampSettings);

    const VIEW_ACTIONS = {
        [APP_VIEWS.ORGANIZERS]: showOrganizers,
        [APP_VIEWS.CAMP_SETTINGS]: showCampSettings
    };

    const handleView = (view) => {
        VIEW_ACTIONS[view]();
        onNavigate();
    };

    return (
        <div className="side-foot">
            {SIDEBAR_FOOTER.map(({ view, label, Icon }) => (
                <button
                    type="button"
                    key={view}
                    className={`side-link${currentView === view ? ' on' : ''}`}
                    onClick={() => handleView(view)}
                >
                    <Icon />
                    {label}
                </button>
            ))}
        </div>
    );
}

SidebarFooter.propTypes = {
    onNavigate: PropTypes.func.isRequired
};
